import React, { useState } from 'react';
import { Box, Stepper, Step, StepLabel, StepConnector, stepConnectorClasses, styled } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupIcon from '@mui/icons-material/Group';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import BriefDetails from './BriefDetails';
import StrategyDetails from './StrategyDetails';
import InfluencerList from './InfluencerList';
import InfluencerFinalCostStep from './InfluencerFinalCostStep';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';


function CampaignSteps({ user }) {
    const [activeStep, setActiveStep] = useState(0);
    const [campaign, setCampaign] = useState({});
    const { id } = useParams();

    // console.log(user , 'user');


    const CustomConnector = styled(StepConnector)(() => ({
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#2a2d3a',
            borderLeftWidth: 1.5,
            minHeight: 16,
            marginLeft: 2,
        },
    }));

    const StepIconRoot = styled('div')(({ active, completed, disabled }) => ({
        width: 24,
        height: 24,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: disabled ? '#e0e0e0' : active || completed ? '#c5e86d' : '#1a1d29',
        color: disabled ? '#aaa' : active || completed ? '#1a1d29' : '#c5e86d',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s',
        '& svg': { fontSize: '0.85rem' },
    }));

    function StepIcon({ active, completed, icon, disabled, label }) {
        const iconMap = {
            'Brand Details': <BusinessIcon />,
            'DM Team Details': <TrendingUpIcon />,
            'Influencer List': <GroupIcon />,
            'Influencer Approve': <HowToRegIcon />,
            'Influencer Final Cost': <AttachMoneyIcon />,
            'Dispatch Details': <LocalShippingIcon />,
            'Content Coordination': <VideoLibraryIcon />,
        };
        return (
            <StepIconRoot active={active} completed={completed} disabled={disabled} >
                {iconMap[label] || <BusinessIcon />}
            </StepIconRoot>
        );
    }

    const fetchCampaignDetails = async (id) => {
        try {
            const { default: api } = await import("../services/api");
            const response = await api.get(`/campaign/${id}`);
            // console.log('test' , response.data?.data.stageStatus);
            setCampaign(response.data?.data || {});
        } catch (error) {
            console.error("Failed to fetch Campaign Details:", error);
        }
    };

    const influencerStepLabel = user.role === 'dm_team' ? 'Influencer Approve' : 'Influencer List';

    const steps = [
        { label: 'Brand Details', component: BriefDetails, disabled: false },
        { label: 'DM Team Details', component: StrategyDetails, disabled: (user.role == 'dm_team' && campaign.stageStatus >= 2) || (user.role == 'brand_team' && campaign.stageStatus >= 3) || (user.role == 'imt_team' && campaign.stageStatus >= 4) ? false : true },
        { label: influencerStepLabel, component: InfluencerList, disabled: (user.role == 'imt_team' && campaign.stageStatus >= 4) || (user.role == 'dm_team' && campaign.stageStatus >= 4) ? false : true },
        {label: 'Influencer Final Cost', component: InfluencerFinalCostStep, disabled: (user.role == 'dm_team' && campaign.stageStatus >= 4 && (campaign.influencerList || []).some(i => i.influencerApprovalId)) ? false : true },
        { label: 'Dispatch Details', component: StrategyDetails, disabled: true },
        { label: 'Content Coordination', component: StrategyDetails, disabled: true },
    ];

    useEffect(() => {
        if (id) fetchCampaignDetails(id);
    }, [id]);

    useEffect(() => {
        if (campaign && Object.keys(campaign).length > 0) {
            if (user.role === 'brand_team') {
                setActiveStep(0);
            } else if (user.role === 'dm_team') {
                setActiveStep(1);
            }
        }
    }, [campaign]);

    const handleStepClick = (index) => {
        if (!steps[index].disabled) {
            setActiveStep(index);
        }
    };

    const ActiveComponent = steps[activeStep].component;

    return (
        <Box sx={{ display: 'flex', gap: 1, p: 1.5 }}>
            <Box sx={{ minWidth: 60 }}>
                <Stepper orientation="vertical" activeStep={activeStep} connector={<CustomConnector />}>
                    {steps.map((step, index) => (
                        <Step key={step.label} onClick={() => handleStepClick(index)}>
                            <StepLabel
                                StepIconComponent={(props) => <StepIcon {...props} disabled={step.disabled} label={step.label} />}
                                sx={{
                                    py: 2,
                                    cursor: step.disabled ? 'not-allowed' : 'pointer',
                                    '& .MuiStepLabel-label': {
                                        fontSize: '12px',
                                        cursor: step.disabled ? 'not-allowed' : 'pointer',
                                        color: index === activeStep ? '#c5e86d' : step.disabled ? '#aaa' : '#333',
                                        fontWeight: index === activeStep ? 600 : 400,
                                    }
                                }}
                            >
                                {step.label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>

            <Box sx={{ flex: 1 }}>
                <ActiveComponent user={user} campaignId={id} />
            </Box>
        </Box>
    );
}
export default CampaignSteps;